import {Component, computed, input, inject} from '@angular/core';
import {RotaDataService} from '../../../../services/store/rota-data.service';
import {DayOfWeek} from '../../../../classes/enums/DayOfWeek';
import {EmployeePositionId} from '../../../../classes/models/employee/Employee';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

/**
 * This component displays the time when an employee is available for the day, on rota daily page.
 */
@Component({
  selector: 'app-rota-day-availability',
  templateUrl: './rota-day-availability.component.html',
  styleUrls: ['./rota-day-availability.component.less'],
  imports: [SHARED_IMPORTS]
})
export class RotaDayAvailabilityComponent {
  private rotaDataService = inject(RotaDataService);


  /** The day of week of a rota. */
  dayOfWeek = input<DayOfWeek>();
  /** Identifiers of an employee and position. */
  employeePositionId = input<EmployeePositionId>();

  /** An assignment when an employee is available. */
  availability = computed(() => {
    return this.rotaDataService.rota()?.availabilityAssignments
            .find(assignment => assignment.hasEqualEmployeeAndDay(this.employeePositionId(), this.dayOfWeek()));
  });


}
